import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';

import classNames from 'classnames';
import TeethImagesConfig from './TeethImagesConfig';

export function Tooth(
  {
    // name // TODO: in the future, the teeth should be checkbocks instead of images by events
    tooth,
    type,
    isSelected,
    enableOverVisualEffect = true,
    onClickHandler,
    disabled,
  }
) {
  const [isOver, setIsOver] = useState(false);

  const toothConfig = TeethImagesConfig[tooth];

  const image = useMemo(
    () => {
      if (isSelected) {
        return toothConfig.toothSelected;
      }
      if (isOver) {
        return toothConfig.toothOver;
      }
      return toothConfig.toothWhite;
    },
    [
      isOver,
      isSelected,
      toothConfig.toothOver,
      toothConfig.toothSelected,
      toothConfig.toothWhite
    ]
  );

  const handleMouseEnter = useCallback(() => {
    if (!disabled) {
      if (enableOverVisualEffect) {
        setIsOver(true);
      }
    }
  }, [disabled, enableOverVisualEffect]);

  const handleMouseLeave = useCallback(() => {
    if (!disabled) {
      if (enableOverVisualEffect) {
        setIsOver(false);
      }
    }
  }, [disabled, enableOverVisualEffect]);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      key={`tooth-${tooth}`}
      tabIndex={tooth}
      role="button"
      className="tooth ms-1"
      onClick={onClickHandler}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* <label
        htmlFor={`tooth-${tooth}`}
      >
        {toothConfig[type]}
      </label>
      <input
        type="checkbox"
        name={`tooth-${tooth}`}
        onClick={onClickHandler}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      /> */}
      <img
        src={image}
        alt="Tooth"
        className={classNames('', {
          flipped: toothConfig.flipped,
          child: tooth > 50,
        })}
      />
      <div
        className={classNames('text-center mt-20', {
          'bg-dark': isOver,
          'bg-opacity-10': isOver,
        })}
      >
        <span
          className={classNames('', {
            'fw-bolder': isSelected,
            'border-top': isSelected,
          })}
        >
          {toothConfig[type]}
        </span>
      </div>
    </div>
  );
}

Tooth.propTypes = {
  // name: PropTypes.string,
  tooth: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  enableOverVisualEffect: PropTypes.bool,
  onClickHandler: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Tooth;
